import { ApiConfig } from "../../../../config"
import { createRequestActionTypes } from "../../../../utils/request-actions-helpers/createRequestActionTypes"
import { Collection } from "../../../../models/Collection"
import { FetchRequestActions } from "../../../../utils/request-actions-helpers/createRequestActions"
import { RequestThunkParameters, createRequestThunk } from "../../../../utils/request-actions-helpers/createRequestThunk"

export const fetchOpenCollectionsActionTypes = createRequestActionTypes('OPEN_COLLECTIONS')

export type FetchOpenCollectionsResult = Collection[]
export type FetchOpenCollectionsActions = FetchRequestActions<FetchOpenCollectionsResult>

export const fetchOpenCollections = (config: ApiConfig) => {
    const thunkParams: RequestThunkParameters<FetchOpenCollectionsResult> = {
        method: 'GET',
        requestActionTypes: fetchOpenCollectionsActionTypes,
        url: `${config.API_URL}/collections/getOpenCollections`
    }
    return createRequestThunk(thunkParams)
}